import React from 'react';
import { Trans } from '@lingui/react';

export default {
    Classes: <Trans>Classes</Trans>,
    'STUDENT MANAGEMENT': <Trans>STUDENT MANAGEMENT</Trans>,
    'WHOLE CLASS': <Trans>WHOLE CLASS</Trans>
};



// WEBPACK FOOTER //
// ./components/page-header/page-header-text.js